module.exports = __webpack_public_path__ + "public/images/prizes/prize-maldives.1e787a527e8b092de70bbed26f32cfaa.png";